// extracted by mini-css-extract-plugin
export default {"shareBtn":"shareBtn_shareBtn__9jK83"};